/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbMetierConseillersLiesGridDto
 */
export interface FcbMetierConseillersLiesGridDto {
    /**
     * 
     * @type {string}
     * @memberof FcbMetierConseillersLiesGridDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbMetierConseillersLiesGridDto
     */
    prenom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbMetierConseillersLiesGridDto
     */
    idConseiller?: string | null;
}

/**
 * Check if a given object implements the FcbMetierConseillersLiesGridDto interface.
 */
export function instanceOfFcbMetierConseillersLiesGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbMetierConseillersLiesGridDtoFromJSON(json: any): FcbMetierConseillersLiesGridDto {
    return FcbMetierConseillersLiesGridDtoFromJSONTyped(json, false);
}

export function FcbMetierConseillersLiesGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbMetierConseillersLiesGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'prenom': !exists(json, 'prenom') ? undefined : json['prenom'],
        'idConseiller': !exists(json, 'idConseiller') ? undefined : json['idConseiller'],
    };
}

export function FcbMetierConseillersLiesGridDtoToJSON(value?: FcbMetierConseillersLiesGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nom': value.nom,
        'prenom': value.prenom,
        'idConseiller': value.idConseiller,
    };
}

